// extracted by mini-css-extract-plugin
export default {"triangle":"jvERjAfnE8BHEu2t4YP2","wrapper":"qgW6KPiDAyP2P6RWMdJz"};